// Copy for watching a lane. ONE place, so the promise stays true everywhere it is shown.
//
// Watching a lane writes a row to frm_rate_alerts and nothing else: no job, worker or trigger in
// this repository (or the neighbouring ones) reads that table to send anything. So the copy may
// promise what shipping code does, a saved list on /account (lane, threshold, Remove), and must
// never promise an email or a rate the list does not show.
// `watch-lane-copy.test.ts` keeps every surface honest.

/** Shown under the button right after a lane is saved. */
export const WATCH_SAVED_MSG = 'Saved to your watched lanes.'

/** Signed-out nudge under "Watch this lane" (the sign-in link follows this sentence). */
export const WATCH_SIGNED_OUT_HINT =
  'Keep this lane in your watched lanes and come back to it from your account.'

/** Empty state of the watched-lanes card on /account. */
export const WATCH_EMPTY_LEAD = 'No watched lanes yet. Open any lane and tap'
export const WATCH_EMPTY_TAIL = 'to keep it in this list.'

/**
 * Pro tier on /pricing (OC-18): a saved list instead of an email promise. The list lives on
 * /account (pinned lanes on the dashboard are a separate, local, free thing), so the copy says
 * "account", not "dashboard".
 */
export const PRICING_PRO_TAGLINE = 'Watch every lane'
export const PRICING_PRO_WHY = 'Watch every lane you run and keep the whole list in your account.'

/** Every copy string above, for the guard test. */
export const WATCH_LANE_COPY = {
  WATCH_SAVED_MSG,
  WATCH_SIGNED_OUT_HINT,
  WATCH_EMPTY_LEAD,
  WATCH_EMPTY_TAIL,
  PRICING_PRO_TAGLINE,
  PRICING_PRO_WHY,
} as const
